import React from 'react';
import { FileText } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Impressum = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8 bg-brand-50">
        <div className="max-w-4xl mx-auto text-center">
          <FileText className="w-16 h-16 text-brand-900 mx-auto mb-6" />
          <h1 className="text-4xl md:text-5xl font-bold text-brand-900 mb-4">
            Impressum
          </h1>
          <p className="text-lg text-brand-700">
            Angaben gemäß § 5 TMG
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          
          {/* Angaben gemäß § 5 TMG */}
          <div className="mb-12 p-8 bg-brand-50 rounded-xl">
            <h2 className="text-3xl font-bold text-brand-900 mb-6">Angaben gemäß § 5 TMG</h2>
            <div className="text-brand-700 leading-relaxed space-y-1">
              <p className="font-semibold text-brand-900 text-lg">Dr. Hans-Dieter Graßl</p>
              <p>Bahnhofstraße 8</p>
              <p>26336 Varel</p>
              <p className="mt-4">Deutschland</p>
            </div>
          </div>

          {/* Kontakt */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-brand-900 mb-4">Kontakt</h2>
            <div className="text-brand-700 leading-relaxed">
              <p>
                <strong className="text-brand-900">E-Mail:</strong>{' '}
                <a href="mailto:hdgdr@icloud.com" className="text-brand-800 hover:text-brand-900 underline">
                  hdgdr@icloud.com
                </a>
              </p>
            </div>
          </div>

          {/* Verantwortlich für den Inhalt */}
          <div className="mb-12 p-8 bg-brand-50 rounded-xl">
            <h2 className="text-3xl font-bold text-brand-900 mb-6">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <div className="text-brand-700 leading-relaxed space-y-1">
              <p className="font-semibold text-brand-900">Dr. Hans-Dieter Graßl</p>
              <p>Bahnhofstraße 8</p>
              <p>26336 Varel</p>
            </div>
          </div>

          {/* Steuernummern */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-brand-900 mb-4">Steuernummern</h2>
            <div className="text-brand-700 leading-relaxed space-y-2">
              <p><strong className="text-brand-900">IdNr:</strong> 79 143 708 564</p>
              <p><strong className="text-brand-900">Steuer-Nr.:</strong> 63/115/05642</p>
              <p><strong className="text-brand-900">Finanzamt:</strong> Nordenham</p>
            </div>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Impressum;
